"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Conditional = exports.DEFAULT_UNAVAILABLE_CAPABILITY = exports.DEFAULT_AVAILABLE_CAPABILITY = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
var DEFAULT_AVAILABLE_CAPABILITY = {
    value: true,
    reasons: []
};
exports.DEFAULT_AVAILABLE_CAPABILITY = DEFAULT_AVAILABLE_CAPABILITY;
var DEFAULT_UNAVAILABLE_CAPABILITY = {
    value: false,
    reasons: []
};
exports.DEFAULT_UNAVAILABLE_CAPABILITY = DEFAULT_UNAVAILABLE_CAPABILITY;
// ------------------- React Views ------------------- //
var Empty = function (props) {
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-view empty" }, { children: props.children }));
};
var Conditional = function (props) {
    var _a, _b;
    var on = props.on, actionable = props.actionable, displayMode = props.displayMode, defaultDisplayNone = props.defaultDisplayNone, displayReasons = props.displayReasons, stringBundle = props.stringBundle, every = props.every, some = props.some, style = props.style;
    var inlineDisplay = displayMode === 'inline';
    var blockDisplay = displayMode === 'block';
    var flexDisplay = displayMode === 'flex';
    var isOn = conditionalUtils.conditionalCapabilityValue(on, every, some);
    var isActionable = conditionalUtils.conditionalCapabilityValue(actionable, every, some);
    var classes = (0, classnames_1["default"])('conditional-view', {
        'default-not-visible': isOn,
        'default-no-interaction': isActionable,
        'inline-mode': inlineDisplay,
        'block-mode': blockDisplay,
        'flex-mode': flexDisplay,
        'default-display-none-on-false': defaultDisplayNone && !isOn
    });
    var shouldShowEmptyMessage = !isOn && displayReasons;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes, style: style }, { children: [isOn && props.children, shouldShowEmptyMessage && blockDisplay && ((0, jsx_runtime_1.jsx)(Empty, { children: conditionalUtils.getStrings(on, (_a = stringBundle === null || stringBundle === void 0 ? void 0 : stringBundle.visible) !== null && _a !== void 0 ? _a : {}) })), shouldShowEmptyMessage && inlineDisplay && ((0, jsx_runtime_1.jsx)("span", { children: conditionalUtils.getStrings(on, (_b = stringBundle === null || stringBundle === void 0 ? void 0 : stringBundle.visible) !== null && _b !== void 0 ? _b : {}) }))] })));
};
exports.Conditional = Conditional;
Conditional.defaultProps = {
    on: __assign({}, DEFAULT_AVAILABLE_CAPABILITY),
    actionable: __assign({}, DEFAULT_AVAILABLE_CAPABILITY),
    displayMode: 'block',
    displayReasons: false,
    stringBundle: {
        visible: {}
    },
    defaultDisplayNone: true
};
Conditional.displayName = 'Conditional';
//# sourceMappingURL=conditional.js.map